export default {module:'Card/Form',view:'Element/Section',options:{xs:12},children:[{config:'ui/web'}]}